var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"is-scrollable"},[(!_vm.error)?_c('router-view',{on:{"error":function($event){_vm.error = true},"loaded":_vm.loaded}}):_c('error')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }